import React, { Fragment, useEffect, useState } from "react";
import {
  getDeliveredOrdersApi,
  getFinishedRequestApi,
} from "../../Api/DeliveryBarest";
import Item from "../Item/Item";
import Modal from "../Modal/Modal";
import OrdersModal from "../OrdersModal/OrdersModal";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";
import Style from "./OrderDelivered.module.css";
import FinishedPeykRequest from "../FinishedPeykRequest/FinishedPeykRequest";
import { errorToast } from "../../Utils/Toast/Toast";
import { Tabs } from "antd";
const OrderDelivered = () => {
  const [purchased, setPurchased] = useState(false);
  const [data, setData] = useState();
  const [productData, setProductData] = useState();
  const [requestState, setRequestState] = useState([]);
  /////get delivered orders ///
  useEffect(() => {
    getDeliveredOrder();
    getFinishedPeykRequest();
  }, []);
  const getDeliveredOrder = async (e) => {
    let val =
      e === undefined
        ? null
        : e.from["year"] + "-" + e.from["month"] + "-" + e.from["day"];
    let valto =
      e === undefined
        ? null
        : e.to["year"] + "-" + e.to["month"] + "-" + e.to["day"];
    const result = await getDeliveredOrdersApi(val, valto);
    setData(result.orders);
  };
  const getFinishedPeykRequest = () => {
    getFinishedRequestApi((res) => {
      if (res.status === 1) {
        setRequestState(res.requests);
      } else {
        errorToast(res.message);
      }
    });
  };
  const closeList = () => {
    setPurchased(false);
  };
  const handleCallback = (childData) => {
    setProductData(childData);
  };
  const items = [
    {
      key: "1",
      label: "تحویل سفارش",
      children: (
        <Item
          btnAccept={false}
          setPurchased={setPurchased}
          deliver={false}
          time={false}
          address={true}
          data={data}
          parentCallback={handleCallback}

        />
      ),
    },
    {
      key: "2",
      label: "پیک",
      children: requestState.map((item) => {
        return <FinishedPeykRequest key={item.id} data={item} />;
      }),
    },
  ];
  let loading = null;
  if (data === undefined) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <div className={Style.pageHolder}>
        <Modal
          show={purchased}
          modalClose={() => setPurchased(false)}
          translate={40}
        >
          <OrdersModal setShow={closeList} data={productData} />
        </Modal>

        <div className={Style.itemHolder}>
          <Tabs
          style={{fontFamily:'iran-sans-num'}}
            centered
            defaultActiveKey="1"
            items={items}
            indicator={{ size: (origin) => origin - 20, align: "center" }}
          />
          {/* <Item
            btnAccept={false}
            setPurchased={setPurchased}
            deliver={false}
            time={false}
            address={true}
            data={data}
            parentCallback={handleCallback}
          />
          {
            requestState.map(item=>{
              return(<FinishedPeykRequest key={item.id} data={item}/>)
            })
          } */}
        </div>
      </div>
    );
  }
  return <Fragment>{loading}</Fragment>;
};

export default OrderDelivered;
